import * as $ajax from './_ajax'
import * as $form from './_form'
import * as $blogpostpopup from './blog.blogpostpopup'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    sort: string
    showInactive: boolean
}

var options: IInitOptions

export function init($options: any): void {
    options = $options

    $('.' + options.pagePrefix + '__search').click(function () {
        var showinactive  = $form.getCheckboxlistValues($('.' + options.pagePrefix + '__showinactive'))
        var parentaccount = $('.' + options.pagePrefix + '__parentaccount').val()
        var statsdays     = $('.' + options.pagePrefix + '__statsdays').val()
        var department    = $('.' + options.pagePrefix + '__department').val()
        var inactive      = $('.' + options.pagePrefix + '__inactive').val()
        var orgsSelect    = $('.' + options.pagePrefix + '__organizations')
        var orgs          = orgsSelect.length
            ? (orgsSelect.val() as string[] || []).join(',')
            : ''
        location.href =
            '/Account/AccountsList?sort=' + options.sort +
            '&inact='    + showinactive +
            '&pant='     + parentaccount +
            '&stats='    + statsdays +
            '&dep='      + department +
            '&inactive=' + inactive +
            '&orgs='     + encodeURIComponent(orgs)
    })

    $('.' + options.pagePrefix + '__department').on('change', () => {
        options.sort = 'paa'
    })

    $('.' + options.pagePrefix + '__clearsearch').click(function () {
        location.href = '/Account/AccountsList?sort=' + options.sort
    })

    $('.' + options.pagePrefix + '__departments').click(function () {
        location.href = '/Account/AccountDepartments'
    })

    $('.' + options.pagePrefix + '-doexpand').click(function () {
        var icon = $(this)
        var id = icon.attr('data-id')
        var expanded = icon.attr('data-expanded') === 'true'
        if (expanded) {
            // hide
            icon.html('<span class="fas fa-chevron-right"></span>')
            icon.attr('data-expanded', 'false')
            $('.' + options.pagePrefix + '-row2-' + id).hide()
        } else {
            // show
            var statsdays = $('.' + options.pagePrefix + '__statsdays').val()
            icon.html('<span class="fas fa-chevron-down"></span>')
            icon.attr('data-expanded', 'true')
            $('.' + options.pagePrefix + '-row2-' + id).show()
            $('.' + options.pagePrefix + '-row2-content-' + id).load(
                '/Account/AccountsListDetails?id=' + id + '&stats=' + statsdays
            )
        }
    })

    $('.' + options.pagePrefix + '-isactive').click(function () {
        var row = $(this).parent()

        $ajax.post({
            loadingText: 'Sparar...',
            url: '/Account/AccountsListSaveStatus',
            data: {
                id: $(this).attr('data-id'),
            },
            success: function (res) {
                if (res.IsActive) {
                    row.removeClass('dimmedinactive')
                    row.find('.' + options.pagePrefix + '-isactive').html(
                        '<span class="fas fa-times"></span>'
                    )
                    row.find('.' + options.pagePrefix + '-deactivated').html('')
                } else {
                    row.addClass('dimmedinactive')
                    row.find('.' + options.pagePrefix + '-isactive').html(
                        '<span class="fas fa-undo"></span>'
                    )
                    row.find('.' + options.pagePrefix + '-deactivated').html(res.Date)
                }
            },
        })
    })

    $blogpostpopup.load(8)
}
